import { createContext, useContext } from 'react';

interface LayoutMetricsContextValue {
  reportTopbarHeight: (height: number) => void;
}

const defaultContext: LayoutMetricsContextValue = {
  reportTopbarHeight: () => undefined,
};

export const LayoutMetricsContext = createContext<LayoutMetricsContextValue>(defaultContext);

export function useLayoutMetrics(): LayoutMetricsContextValue {
  return useContext(LayoutMetricsContext);
}
